var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarth = function SvgEarth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#earth_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#2D4E6D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33,
    d: "M14.36 10h-3.026A1.333 1.333 0 0 0 10 11.333v3.027M4.667 2.227v1.106a2 2 0 0 0 2 2A1.333 1.333 0 0 1 8 6.667a1.333 1.333 0 0 0 2.667 0c0-.734.6-1.334 1.333-1.334h2.114m-6.78 9.3V12A1.333 1.333 0 0 0 6 10.667a1.333 1.333 0 0 1-1.333-1.334v-.666a1.333 1.333 0 0 0-1.334-1.334H1.367m13.3.667A6.667 6.667 0 1 1 1.334 8a6.667 6.667 0 0 1 13.333 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "earth_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgEarth;